import { render } from "./Claim4.vue?vue&type=template&id=7f4a3612&scoped=true"
import script from "./Claim4.vue?vue&type=script&lang=js"
export * from "./Claim4.vue?vue&type=script&lang=js"

import "./Claim4.vue?vue&type=style&index=0&id=7f4a3612&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f4a3612"

export default script